import React from 'react';

function QuienesSomos() {
  return (
    <div className="page">
      <h1>Quiénes somos</h1>
      <p>
        Nexo nació en 2023 en Vitoria-Gasteiz con la idea de crear una comunidad apasionada por los juegos de rol y de mesa. Estamos ubicados en Guatemala Kalea, 01012 Vitoria-Gasteiz, Araba. Somos un grupo de amigos que decidió convertir nuestra pasión en un espacio abierto para todos. Organizamos partidas, talleres y eventos para socios y nuevos jugadores.
      </p>
    </div>
  );
}

export default QuienesSomos;